import React from "react";
import {
  ThemeProvider,
  CSSReset,
  ColorModeProvider,
} from "@chakra-ui/core";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import "./App.css"

//Theme
import { customTheme } from "./theme";

//Components
import NavigationBar from './components/NavBar'
import Footer from './components/Footer'

//Private Route
import PrivateRoute from './components/PrivateRoute'

//Pages
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import MenuEdit from './pages/MenuEdit'
import SignUp from './pages/SignUp'
import Login from './pages/Login'

const App = () => {

  return (
    <div className="App">
      <ThemeProvider theme={customTheme}>
        <ColorModeProvider>
          <CSSReset />

          <Router>
            <NavigationBar />
            <Switch>
              <Route path="/" exact component={Home} />
              <PrivateRoute path="/dashboard" exact component={Dashboard} />
              <PrivateRoute path="/menu" exact component={MenuEdit} />
              <Route path="/signup" exact component={SignUp} />
              <Route path="/login" exact component={Login} />
            </Switch>
            <Footer />
          </Router>

        </ColorModeProvider>
      </ThemeProvider>
    </div>
  )
}
export default App;
